import type { GameData } from "@/app/games/(details)/types";
import { useGameDetailsContext } from "@/context/GameDetailsContext";
import { useCallback } from "react";
import { ArtGalleryCarousel } from "../ArtGallery/ArtGalleryCarousel";
import { GameplayCarousel } from "../Gameplay/GameplayCarousel";
import { TrailerPlayer } from "../TrailerPlayer/TrailerPlayer";
import { QuestBox } from "./QuestBox";

export const BentoBox = ({
  gameData,
}: {
  gameData: GameData;
}) => {
  const { incompleteQuests, isWishlisted, onQuestClick } =
    useGameDetailsContext();
  const nextQuest =
    incompleteQuests.length > 0 ? incompleteQuests[0] : undefined;

  const handleOnQuestClick = useCallback(() => {
    if (!nextQuest) return;

    onQuestClick(nextQuest);
  }, [nextQuest, onQuestClick]);

  return (
    <div
      className="grid grid-cols-2 flex-grow
    [@media(max-aspect-ratio:4/3)]:auto-rows-[minmax(100px,120px)]  
    [@media(min-aspect-ratio:4/3)]:grid-flow-col 
    [@media(min-aspect-ratio:4/3)]:grid-cols-4
    gap-y-2.5 gap-x-2.5 w-full"
    >
      <TrailerPlayer
        gameData={gameData}
        className="w-full h-full
        row-span-2 col-span-2 
        [@media(min-aspect-ratio:4/3)]:row-span-6 
        [@media(min-aspect-ratio:4/3)]:col-span-2"
      />

      {isWishlisted && nextQuest ? (
        <QuestBox
          gameData={gameData}
          quest={nextQuest}
          backgroundMediaUrl={gameData.gameContent?.splash_urls?.[0] ?? ""}
          onClick={handleOnQuestClick}
          className="w-full h-full 
          row-span-2 
          [@media(min-aspect-ratio:4/3)]:row-span-6"
        />
      ) : null}

      <ArtGalleryCarousel
        gameData={gameData}
        className={`${
          isWishlisted && nextQuest
            ? "[@media(min-aspect-ratio:4/3)]:row-span-3"
            : "[@media(min-aspect-ratio:4/3)]:row-span-6"
        }`}
      />
      <GameplayCarousel
        gameData={gameData}
        className={`${
          isWishlisted && nextQuest
            ? "[@media(min-aspect-ratio:4/3)]:row-span-3"
            : "[@media(min-aspect-ratio:4/3)]:row-span-6"
        }`}
      />
    </div>
  );
};
